import React from "react"
import Layout from "../../components/layout"
import { InternalPage } from "components/InternalPage"
import SEO from "../../components/seo"

import { parseBlockContent } from "../../utils/customBlocks"

const Internal = ({ pageContext }) => {
  const {
    title,
    content,
    legAncestors,
    link,
    slug,
    subsiteFooter,
    featuredImage,
    relatedContent,
    tags,
    previewSQ
  } = pageContext
  console.log('content:', content)

  const customContent = content ? parseBlockContent(content) : null

  console.log(subsiteFooter)

  return (
    <Layout
      internal
      subsite
      preview={previewSQ}
      slug={slug}
      headerTitle={title}
      ancestors={legAncestors}
      headerImg={featuredImage}
      bottomSection={subsiteFooter}
    >
      <SEO title={title} image={featuredImage?.sourceUrl} />
      <InternalPage
        content={customContent}
        currentPageLink={link}
        ancestors={legAncestors}
        relatedContent={relatedContent}
        tags={tags}
      />
    </Layout>
  )
}

export default Internal
